import React, { ReactNode } from 'react'

import { TranslationsProvider } from '@hhgtech/hhg-components/i18n'

type Props = {
  children?: ReactNode
}

/** Provides hhg-components translations (SSOV2, etc.) — separate from react-intl. */
export const TranslationsWrapper = ({ children }: Props) => {
  return (
    <TranslationsProvider locale="vi-VN_MB">{children}</TranslationsProvider>
  )
}
